import type { MessageDescriptor } from 'react-intl';
import type { FieldError } from '../../../types/form/Element';

export const isMessageDescriptor = (
  error: FieldError | MessageDescriptor,
): error is MessageDescriptor => {
  return typeof error === 'object' && 'id' in error;
};

export const isFieldError = (
  error: FieldError | MessageDescriptor,
): error is FieldError => {
  return typeof error === 'object' && 'message' in error;
};
